import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IActivityItemsHW,
  ISemesterTimetable,
} from '../../../models/semesterProduct.model';
import { TableColumnsType, Select, Table } from 'antd';
import { IEvaluationItemTree } from '../../../models/evaluationItem.model';
import { getCommonCodeLabel } from '../../../lib/store';
import Button from '../../Button';

interface ITimeTable {
  monthSeq: number;
  monthNameCode: string;
  timetableSeq: number;
  times: number;
}

interface IProps {
  semesterTimetables: ISemesterTimetable[];
  evaluationItemTree: IEvaluationItemTree[];
  activityItemsHW: IActivityItemsHW[];

  onRowClick(timetableSeq: number): void;

  onSubmit(record: IActivityItemsHW): void;

  onDelete(value: number): void;
}

const { Option } = Select;

const EvaluationHWTable: FC<IProps> = ({
  semesterTimetables,
  evaluationItemTree,
  activityItemsHW,
  onRowClick,
  onSubmit,
  onDelete,
}) => {
  const { t } = useTranslation();
  const [courseTimesList, setCourseTimesList] = useState<ITimeTable[]>([]);
  const [timetableSeq, setTimetableSeq] = useState<number>();
  const [tableActivityItemsHW, setTableActivityItemsHW] = useState<
    IActivityItemsHW[]
  >([]);

  useEffect(() => {
    const data: ITimeTable[] = [];
    let i = 0;
    let j = 0;
    for (const {
      monthSeq,
      monthNameCode,
      timetableSeq,
    } of semesterTimetables) {
      for (const timetableSeqNumber of timetableSeq) {
        console.log('timetableSeqNumber: ', timetableSeqNumber);
        console.log('i * j : ', i * j);
        console.log('i: ', i);
        console.log('j: ', j);
        data.push({
          monthSeq,
          monthNameCode,
          timetableSeq: timetableSeqNumber,
          times: timetableSeqNumber - i * j,
        });
        if (i === 0) j = timetableSeqNumber;
      }
      i++;
    }

    setCourseTimesList(data);
  }, [semesterTimetables]);

  useEffect(() => {
    setTableActivityItemsHW([
      ...activityItemsHW,
      {
        evaluationItemCode: 0,
        semesterSeqEvaluationCode: 0,
      },
    ]);
  }, [activityItemsHW]);

  const onEvaluationItemCodesChange = (value: number, index: number) => {
    const newTableActivityItemsHW = [...tableActivityItemsHW];
    newTableActivityItemsHW[index].evaluationItemCode = value;
    setTableActivityItemsHW(newTableActivityItemsHW);
  };

  const onLocalDelete = (value: number, index: number) => {
    if (value === 0) {
      setTableActivityItemsHW(
        tableActivityItemsHW.filter((_, index2) => index !== index2),
      );
    } else {
      onDelete(value);
    }
  };

  const columns: TableColumnsType<IActivityItemsHW> = [
    {
      title: 'Activity',
      key: 'evaluationItemCode',
      dataIndex: 'evaluationItemCode',
      render: (value: number | null, _, index) => (
        <Select
          defaultValue={value}
          value={tableActivityItemsHW[index].evaluationItemCode}
          onChange={(value) => onEvaluationItemCodesChange(value, index)}
          style={{ width: '100%' }}
        >
          <Option value={0}>{t('common.button.select')}</Option>
          {evaluationItemTree.map(
            ({ evaluationItemCode, evaluationItemName }) => (
              <Option value={evaluationItemCode}>{evaluationItemName}</Option>
            ),
          )}
        </Select>
      ),
    },
    {
      title: t('common.button.save'),
      key: 'semesterSeqEvaluationCode',
      dataIndex: 'semesterSeqEvaluationCode',
      render: (value, record) => (
        <Button
          className="btn btn-secondary btn-w70p mr-1"
          onClick={() => onSubmit(record)}
          text={t('common.button.save')}
        />
      ),
    },
    {
      title: t('common.button.delete'),
      key: 'semesterSeqEvaluationCode',
      dataIndex: 'semesterSeqEvaluationCode',
      render: (value, _, index) => (
        <Button
          className="btn btn-secondary btn-w70p mr-1"
          onClick={() => onLocalDelete(value, index)}
          text={t('common.button.delete')}
        />
      ),
    },
  ];

  const onRowAdd = () => {
    const newTableActivityItemsHW = [...tableActivityItemsHW];
    newTableActivityItemsHW.push({
      evaluationItemCode: 0,
      semesterSeqEvaluationCode: 0,
    });
    setTableActivityItemsHW(newTableActivityItemsHW);
  };

  return (
    <div className="flex flex-column">
      <div className="text-right flex flex-justify-end">
        <Button
          className="btn btn-primary btn-w100p"
          text={t('program.semester.button6')}
          onClick={onRowAdd}
        />
      </div>
      <div className="flex">
        <div className="col-4">
          <div>
            <div className="card">
              <div className="card-body">
                <table className="table table-bordered table-basic">
                  <colgroup>
                    <col width="50%" />
                    <col width="50%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="text-center">
                        {t('program.semester.column22')}
                      </th>
                      <th className="text-center">
                        {t('program.semester.column23')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {courseTimesList.map((item: ITimeTable, index: number) => (
                      <tr
                        key={index}
                        className={
                          timetableSeq === item.timetableSeq
                            ? ' chosen'
                            : 'pointer'
                        }
                        onClick={() => {
                          onRowClick(item.timetableSeq);
                          setTimetableSeq(item.timetableSeq);
                        }}
                      >
                        <td className="text-center">
                          {getCommonCodeLabel(
                            'SY0009',
                            item.monthNameCode,
                            'ko',
                          )}
                        </td>
                        <td className="text-center">{item.times}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-8">
          <Table
            columns={columns}
            dataSource={tableActivityItemsHW}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};

export default EvaluationHWTable;
